// extracted by mini-css-extract-plugin
export default {"root":"LandingLayout_root__QoBBH","container":"LandingLayout_container__Q7u1B","header":"LandingLayout_header__FELFn","body":"LandingLayout_body__njST+"};